module.exports = __webpack_public_path__ + "img/1.029104e4.png";